var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 item-holder",
      style: `width: 15rem; height: 80px; border-left: 6px solid  ${
        !_vm.isInner ? _vm.color : "transparent"
      }`,
      on: {
        click: function ($event) {
          return _vm.toggleCollapse()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-row items-center content-center h-full leading-tight",
        },
        [
          !_vm.isInner
            ? _c("span", [
                !_vm.isOpened
                  ? _c(
                      "svg",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "13",
                          height: "8",
                          viewBox: "0 0 13 8",
                          fill: "none",
                          if: "isOpened",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M0.516455 2.97877L5.02816 7.49047C5.70753 8.16984 6.80497 8.16984 7.48434 7.49047L11.996 2.97877C13.0935 1.88133 12.3096 0 10.7592 0H1.73583C0.18548 0 -0.580987 1.88133 0.516455 2.97877Z",
                            fill: "#CACACA",
                          },
                        }),
                      ]
                    )
                  : _c(
                      "svg",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "13",
                          height: "8",
                          viewBox: "0 0 13 8",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.9914 5.02123L7.47965 0.509527C6.80028 -0.169841 5.70284 -0.169841 5.02347 0.509527L0.511771 5.02123C-0.58567 6.11867 0.198217 8 1.74857 8L10.772 8C12.3223 8 13.0888 6.11867 11.9914 5.02123Z",
                            fill: "#CACACA",
                          },
                        }),
                      ]
                    ),
              ])
            : _c("span", { staticClass: "ml-3" }),
          _c(
            "div",
            { staticClass: "ml-3" },
            [
              _c("SchedulerItemAvatar", {
                staticStyle: { width: "33px ,height:32px" },
                attrs: {
                  avatar: _vm.item.avatar,
                  title: _vm.item.name,
                  small: false,
                },
                on: {
                  mouseover: function ($event) {
                    return _vm.toggleInfoCard()
                  },
                  mouseleave: function ($event) {
                    return _vm.toggleInfoCardOff()
                  },
                },
              }),
              _vm.isShowInfor
                ? _c("EmployeeHoverCard", {
                    attrs: {
                      manager: _vm.manager,
                      projects: _vm.projects,
                      contractors: _vm.contractors,
                      isManager: _vm.isManager,
                      employee: _vm.item,
                      projectsInprogress: _vm.projectsInprogress,
                      projectsCompleted: _vm.projectsCompleted,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("span", { staticClass: "text ml-5" }, [
            _vm._v(_vm._s(_vm.item.name)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }